import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import SeoContentSection from './components/SeoContentSection';
import CtaBanner from './components/CtaBanner';
import TestimonialSection from './components/TestimonialSection';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://cssbuyspreadsheet.cc';

const homeJsonLd = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'WebSite',
      '@id': `${siteUrl}/#website`,
      url: siteUrl,
      name: 'CSSBuy Spreadsheet',
      description: 'CSSBuy Spreadsheet é a ferramenta definitiva para compras internacionais da China. Guia completo com comparação de agentes, tutoriais passo a passo, dicas de economia e segurança.',
      inLanguage: 'pt-PT',
      potentialAction: {
        '@type': 'SearchAction',
        target: {
          '@type': 'EntryPoint',
          urlTemplate: `${siteUrl}/artigo/{search_term_string}`,
        },
        'query-input': 'required name=search_term_string',
      },
    },
    {
      '@type': 'Organization',
      '@id': `${siteUrl}/#organization`,
      name: 'CSSBuy Spreadsheet',
      url: siteUrl,
      description: 'Guia completo e ferramenta de organização para compras internacionais da China com CSSBuy Spreadsheet.',
      sameAs: [
        'https://kaspreadsheet.com/',
      ],
    },
  ],
};

export default function Home() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(homeJsonLd) }}
      />
      <Navbar />
      <main>
        <HeroSection />
        <CategorySection />
        <SeoContentSection />
        <CtaBanner />
        <TestimonialSection />
      </main>
      <Footer />
    </>
  );
}